module.exports = __webpack_public_path__ + "img/personInfo.08a33112.png";